import type { Ref, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface FilterChipButtonProps {
  className?: string;
  isActive?: boolean;
  onClick?: () => unknown;
  children: ReactNode;
  ref: Ref<HTMLButtonElement>;
}

export default function FilterChipButton({
  className,
  children,
  onClick = () => null,
  isActive = false,
  ref,
}: FilterChipButtonProps) {
  const activeClassName = isActive
    ? 'bg-pmw-fc-brand080-light dark:bg-pmw-fc-brand120-dark border-pmw-s-brand-light dark:border-pmw-s-brand-dark text-pmw-label-primary-light dark:text-pmw-label-primary-dark'
    : 'border-pmw-separator-light dark:border-pmw-separator-dark bg-pmw-sb-2-secondary-light dark:bg-pmw-sb-2-secondary-dark text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark';

  return (
    <button
      ref={ref}
      className={twMerge(
        'shrink-0 py-2 px-4 border rounded-full cursor-pointer',
        activeClassName,
        className,
      )}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
